import tableMixin from '@/mixins/table'
import Layout from '@/components/layout/app-layout'
import PageHeader from '@/components/layout/page-header'
import api from '@/helpers/api'
export default {
  mixins: [tableMixin],
  components: {
    Layout,
    PageHeader
  },
  data: () => ({
    isLoading: false,
    search: null,
    showForm: false,
    fields: []
  }),
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh'
  },
  computed: {
    filters () {
      return []
    }
  },
  methods: {
    onNewHandler () {
      this.showForm = true
    },
    onNewProductCreated (product) {
      this.$router.push({ name: 'products.view', params: { id: product.id } })
    },
    async onRefresh () {
      this.isLoading = true

      let { items, total_rows } = await api.items.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        filters: [...this.filters]
      })

      this.data = items.map(p => {
        let stock_level_percentage = 0
        let stock_color = 'secondary'
        if (p.is_stock_item) {
          stock_level_percentage = Math.floor(
            (p.stock_value / p.max_stock_value) * 100
          )
          if (stock_level_percentage < 0) stock_level_percentage = 0
          if (p.stock_level <= p.reorder_stock_value) {
            stock_color = 'danger'
          } else {
            stock_color = 'success'
          }
        }
        return {
          ...p,
          stock_level_percentage,
          stock_color
        }
      })
      this.totalRows = total_rows
      this.isLoading = false
    }
  }
}
